import { render, staticRenderFns } from "./mobileRegister.vue?vue&type=template&id=c57d1624&scoped=true"
import script from "./mobileRegister.vue?vue&type=script&lang=js"
export * from "./mobileRegister.vue?vue&type=script&lang=js"
import style0 from "./mobileRegister.vue?vue&type=style&index=0&id=c57d1624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57d1624",
  null
  
)

export default component.exports